import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { ContinuationMode, DayOfWeek, Frequency, SchedulerDefinition, WeeklySchedulerDefinition } from '../../../../api/scheduler-service';
import { SchedulerOptionsComponent } from '../scheduler-options-component';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'weekly-schedule-options',
  imports: [MatCardModule, CommonModule, MatSlideToggleModule, MatButtonToggleModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatChipsModule, MatSelectModule],
  templateUrl: './weekly-schedule-options.component.html',
  styleUrl: './weekly-schedule-options.component.css'
})
export class WeeklyScheduleOptionsComponent implements OnInit, SchedulerOptionsComponent {

  @Input() valueChange : Function | undefined;
  
  ngOnInit(): void {
    this.weeklyOtionsSelectedWeekday.valueChanges.subscribe(val => {
      if (val == null) {
        // If user attempts to deselect the only chip, revert to last valid selection.
        this.weeklyOtionsSelectedWeekday.setValue(this.lastSelectedDayOfWeek, { emitEvent: false });
      } else {
        this.lastSelectedDayOfWeek = val;
      }
    });

    setTimeout(() => this.weeklyOptionsForm.valueChanges.subscribe(() => {
      if (this.valueChange != undefined) {
        this.valueChange();
      }
    }), 0);

  }

  weekdays = Object.values(DayOfWeek);
  lastSelectedDayOfWeek : string = DayOfWeek.Monday;
  continuationModes = Object.values(ContinuationMode);

  
  interval : FormControl = new FormControl(1, Validators.min(1));
  weeklyOtionsSelectedWeekday : FormControl = new FormControl(DayOfWeek.Monday, [Validators.required]);
  continuationMode: FormControl = new FormControl(ContinuationMode.Strict);
  dependency: FormControl = new FormControl(false);

  weeklyOptionsForm: FormGroup = new FormGroup({
    "interval" : this.interval,
    "selectedWeekday" : this.weeklyOtionsSelectedWeekday,
    "continuationMode" : this.continuationMode,
    "dependency": this.dependency
  });

  getSchedulerDefinition() : SchedulerDefinition {
    const schedulerDefinition: WeeklySchedulerDefinition = {
      frequency: Frequency.Weekly,
      interval: this.interval.value,
      weekday: this.weeklyOtionsSelectedWeekday.value,
      continuationMode: this.continuationMode.value,
      eventDependency: this.dependency.value,
    };
    return schedulerDefinition;
  }

  getIntervalSuffix() : string {
    return (this.interval.value > 1) ? "weeks" : "week";
  }

  intervalHasError() : boolean {
    return !this.interval.valid;
  }

  intervalErrorMessage() : string {
    if (this.interval.hasError("min")) {
      return "Interval must be 1 or higher";
    }

    return "";
  }
}
